import React from 'react';
import { ICheckboxOption } from './interfaces';
import { Checkbox, FormControlLabel } from '@mui/material';

export const CheckboxOption: React.FC<ICheckboxOption> = ({
  label,
  checked,
  onChange,
}): JSX.Element => {
  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={checked}
          onChange={(event, checked) => (onChange ? onChange(checked) : null)}
          name={label}
          sx={{
            '& .MuiSvgIcon-root': {
              fontSize: '20px',
            },
          }}
        />
      }
      label={label}
      slotProps={{
        typography: {
          fontSize: '.9rem',
        },
      }}
    />
  );
};
